import React from "react";
import EditorTracker from "./EditorTracker";
import { useEffect, useRef } from "react";

export const MiddlePortion = (props) => {
  return (
    <div className="tdStyle2">
      <div className="centeralWrapper">
        <div className="centerTopContent">
          <EditorTracker key={"ET1"} />
        </div>
      </div>
    </div>
  );
};
export default MiddlePortion;
